module.exports = __webpack_public_path__ + "static/video-1-8fdea919fa06c32ba9023cb3a65cce70.jpg";